// extracted by mini-css-extract-plugin
export default {"fullMaxWidth":"UM-z","carouselContainer":"VM-z"};